import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { Helmet } from "react-helmet";

import Loader from "../../common/Loader";
import PageTitle from "../../common/PageTitle";
import { getFuelTanks } from "../../services/turgoil-api";

const FuelTanksPage = (): React.ReactElement => {
    const [loading, setLoading] = useState(true);
    const [fuelTanks, setFuelTanks] = useState<any[]>([]);

    useEffect(() => {
        getFuelTanks()
            .then((res) => {
                setLoading(false);
                setFuelTanks(res.fuelTanks || []);
            })
            .catch((err) => {
                setLoading(false);
                console.error(err);
            });
    }, []);

    return (
        <>
            <Helmet>
                <title>Turgoil - Mahutid</title>
                <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
            </Helmet>
            <PageTitle>Mahutid</PageTitle>
            {loading && <Loader />}
            {!loading && (
                <>
                    {fuelTanks.length === 0 && <span>Ei leitud ühtegi mahutit.</span>}
                    <Table responsive>
                        <thead>
                            <tr>
                                <th>aiIndex</th>
                                <th>aiMode</th>
                                <th>aiValueRaw</th>
                                <th>aiValueScaled</th>
                                <th>aiValueRawMin</th>
                                <th>aiValueRawMax</th>
                                <th>aiValueScaledMin</th>
                                <th>aiValueScaledMax</th>
                                <th>aiResetMinValue</th>
                                <th>aiResetMaxValue</th>
                                <th>aiStatus</th>
                                <th>aiBurnoutValue</th>
                            </tr>
                        </thead>
                        <tbody>
                            {fuelTanks.map((f) => (
                                <tr>
                                    <td>{f.aiIndex}</td>
                                    <td>{f.aiMode}</td>
                                    <td>{f.aiValueRaw}</td>
                                    <td>{f.aiValueScaled}</td>
                                    <td>{f.aiValueRawMin}</td>
                                    <td>{f.aiValueRawMax}</td>
                                    <td>{f.aiValueScaledMin}</td>
                                    <td>{f.aiValueScaledMax}</td>
                                    <td>{f.aiResetMinValue}</td>
                                    <td>{f.aiResetMaxValue}</td>
                                    <td>{f.aiStatus}</td>
                                    <td>{f.aiBurnoutValue}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </>
            )}
        </>
    )
}

export default FuelTanksPage;
